// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__DgzGU","btn":"Pagination_btn__8zdFY","input":"Pagination_input__w2-ik"};